import { useEffect, useState } from 'react'
import { chatService } from 'services/ChatService'
import { AsyncHookResponse } from 'types/'

const useChatImagePrompt = (value: string): AsyncHookResponse<string> => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [result, setResult] = useState<string>()

  const fetchAIResponse = (value: string) => {
    setLoading(true)
    setError(false)

    chatService
      .getImageResponse(value)
      .then((promptResponse) => {
        setResult(promptResponse)
        setLoading(false)
      })
      .catch((e) => {
        console.error('Error:', e)
        setError(true)
        setLoading(false)
      })
  }

  useEffect(() => {
    if (value) {
      fetchAIResponse(value)
    }
  }, [value])

  return { result, loading, error }
}

export default useChatImagePrompt
